/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import React, { useEffect, useRef, useState } from 'react';
import {
  StyleSheet,
  View,
  TouchableOpacity,
  FlatList,
  Dimensions,
} from 'react-native';
import { Loader } from '@components/screen/Layout';
import MenuScreen from '@components/screen/MenuScreen';
import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';

function BrandCatalogScreen(props) {
  const tableRef = useRef();
  const [header, setHeader] = useState('');
  const [list, setList] = useState([]);
  const [fiteredList, setFilteredList] = useState([]);
  const dimension = Dimensions.get('window');
  const HEADER = [
    {
      label: 'Brand Name',
      data: 'name',
      width: '50%',
    },
  ];

  const HEADER_DEKSTOP = [
    {
      label: 'Brand Name',
      data: 'name',
      width: '50%',
    },
    {
      label: 'Total Product',
      data: 'total_products',
      width: '50%',
    },
  ];
  const brandsLetter = useApi(MsCatalog.getBrandsLetter);
  const alphabet = [];

  const Item = ({ data, index, style }) => (
    <SociollaText style={[styles.columnRowTxt, style]}>{data}</SociollaText>
  );

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => gotToProduct(item)}
      key={'list-brand-' + index}
      style={[
        styles.tableRow,
        { backgroundColor: item.alphabet ? '#F7F7F7' : '#FFFFFF' },
      ]}>
      {HEADER.map((column, index2) => {
        {
          return (
            <SociollaText
              key={'list-brand-' + index + '-' + index2}
              index={index}>
              {item[column.data]}
            </SociollaText>
          );
        }
      })}
    </TouchableOpacity>
  );

  const renderItemDesktop = ({ item, index }) => (
    <TouchableOpacity
      onPress={() => gotToProduct(item)}
      key={'list-brand-' + index}
      style={[
        styles.tableRowDekstop,
        { backgroundColor: item.alphabet ? '#F7F7F7' : '#FFFFFF' },
      ]}>
      {HEADER_DEKSTOP.map((column, index2) => {
        {
          return (
            <Item
              key={'list-brand-' + index + '-' + index2}
              data={item[column.data]}
              index={index}
              style={{ width: column.width }}
            />
          );
        }
      })}
    </TouchableOpacity>
  );

  const renderHeader = () => (
    <FlatList
      horizontal
      data={alphabet}
      style={styles.tableSubHeader}
      keyExtractor={(item, index) => `${item.name}-${index}`}
      renderItem={({ item, index }) => (
        <TouchableOpacity
          key={index}
          style={[styles.columnTable, { paddingHorizontal: 15 }]}
          onPress={() => scroll(item.index)}>
          <SociollaText>{item.name}</SociollaText>
        </TouchableOpacity>
      )}
      showsHorizontalScrollIndicator={false}
    />
  );

  const renderHeaderDekstop = () => (
    <>
      <View style={styles.tableHeader}>
        {HEADER_DEKSTOP.map((column, index) => {
          {
            return (
              <TouchableOpacity
                key={index}
                style={[
                  styles.columnTable,
                  { width: column.width },
                  index + 1 < HEADER_DEKSTOP.length
                    ? {
                        borderRightColor: Colors.white,
                        borderRightWidth: 2,
                        height: 48,
                      }
                    : {},
                ]}>
                <SociollaText style={styles.columnTableTxt}>
                  {column.label}
                </SociollaText>
              </TouchableOpacity>
            );
          }
        })}
      </View>
      <View style={[styles.tableSubHeader, styles.tableSubHeaderWeb]}>
        {alphabet.map((alp, index) => {
          {
            return (
              <TouchableOpacity
                key={index}
                style={[
                  styles.columnTable,
                  { width: '3.7%', paddingHorizontal: 15 },
                ]}
                onPress={() => scroll(alp.index)}>
                <SociollaText>{alp.name}</SociollaText>
              </TouchableOpacity>
            );
          }
        })}
      </View>
    </>
  );

  const scroll = (idx) => {
    try {
      if (idx > 0) {
        tableRef.current.scrollToIndex({
          index: idx,
          viewOffset: isWeb ? 100 : 50,
        });
      }
    } catch (error) {}
  };

  const searchBrand = (value) => {
    const val = value.toLowerCase();
    let newList = [...list];
    if (val && val.length > 2) {
      newList = [...list].filter(
        (x) => !x.alphabet && x.name.toLowerCase().includes(val),
      );
    }
    setFilteredList(newList);
  };

  const gotToProduct = (brand) => {
    if (!brand || !brand.name || !brand._id) {
      return false;
    }
    props.navigation.navigate('ProductCatalogScreen', {
      name: brand.name,
      id: brand._id,
    });
  };

  const generateData = (data) => {
    let newData = [];
    const char = [];
    let index = 0;
    for (const [key, value] of Object.entries(data)) {
      const obj = {
        name: key,
        active: Boolean(value.length),
        alphabet: true,
        index,
      };
      alphabet.push(obj);
      if (value.length) {
        newData = newData.concat([obj, ...value]);
        index += value.length + 1;
      } else {
        newData.push(obj);
        index++;
      }
    }
    return newData;
  };

  useEffect(() => {
    let isMounted = true;
    const getBrands = async () => {
      try {
        const response = await brandsLetter.request();
        if (response.status === 200) {
          const data = generateData(response.data.data);
          setList(data);
          setFilteredList(data);
          if (isWeb) {
            setHeader(renderHeaderDekstop);
          } else {
            setHeader(renderHeader);
          }
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (isMounted) {
      getBrands();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <MenuScreen>
      {isWeb && (
        <SociollaText
          type="medium"
          color="#171D29"
          style={{ marginBottom: 40, fontSize: 24 }}
          onPress={scroll}>
          Product Catalog
        </SociollaText>
      )}
      {brandsLetter.loading ? (
        <Loader />
      ) : (
        list.length > 0 && (
          <SociollaTable
            table={isWeb ? HEADER_DEKSTOP : HEADER}
            datas={fiteredList}
            itemComponent={isWeb ? renderItemDesktop : renderItem}
            headerComponent={header}
            ref={tableRef}
            stickyHeaderIndices={[0]}
            scrollItem={true}
            showSearch={true}
            maxHeight={isWeb ? dimension.height - 250 : dimension.height - 120}
            searchPlaceholder={'Search brands...'}
            onSearch={(value) => searchBrand(value)}
            onReset={() => setFilteredList(list)}
          />
        )
      )}
    </MenuScreen>
  );
}

const styles = StyleSheet.create({
  tableHeader: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    backgroundColor: Colors.blue3,
    height: 48,
    width: '100%',
  },
  tableSubHeader: {
    backgroundColor: Colors.white,
    height: 48,
    width: '100%',
    paddingLeft: 5,
  },
  tableSubHeaderWeb: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  tableRow: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: 48,
    width: '100%',
    borderBottomColor: Colors.grey8,
    borderBottomWidth: 1,
    paddingLeft: 20,
  },
  tableRowDekstop: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: 48,
    width: '100%',
    borderBottomColor: Colors.grey8,
    borderBottomWidth: 1,
  },
  columnTable: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  columnTableTxt: {
    color: 'white',
    fontWeight: 'bold',
  },
  columnRowTxt: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 20,
  },
});

export default BrandCatalogScreen;
